import { useCallback } from 'react';
import { getCookie, removeCookie } from '@app/utils';
import { useAnalytics } from '@app/hooks';
import { useSelector } from 'react-redux';

const useQuickOrderGA = () => {
  const dealerStore = useSelector(s => s.common?.storeLocationName);
  const { fireAddToCartEvent } = useAnalytics();
  const getProductName = useCallback((products, gaProductsData) => {
    return products.map(product => {
      const orders = gaProductsData?.find(
        order => order.id === product.partNumber
      );
      return {
        ...orders,
        partNumber: product.partNumber,
        quantity: product.quantity
      };
    });
  }, []);
  const fireQOAddToCartGAEvent = useCallback(
    (gaProductsData, cookieName) => {
      const cookieValue = getCookie(cookieName) || '';
      if (cookieValue) {
        removeCookie(cookieName);
        const cookieValueDecoded = decodeURIComponent(cookieValue);
        const rows = cookieValueDecoded?.split('||');
        const items = rows.reduce((acc, row, index) => {
          const values = row?.split('~');
          acc[index] = {
            partNumber: values[0] || '',
            quantity: values[1] || ''
          };
          return acc;
        }, []);
        const result = items.filter(val => val.quantity && val.partNumber);
        const products =
          !!gaProductsData?.length && getProductName(result, gaProductsData);
        fireAddToCartEvent({ products, dealerStore });
      }
    },
    [getProductName, fireAddToCartEvent]
  );
  return {
    fireQOAddToCartGAEvent
  };
};

export default useQuickOrderGA;
